export var textareaDefaultProps = {
  name: null,
  value: "",
  className: "",
  autoComplete: "off",
  isDisabled: false,
  isReadOnly: false,
  placeholder: null,
  onChange: function onChange() {},
  onKeyPress: function onKeyPress() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  required: true,
  minLength: "",
  maxLength: "",
  autoFocus: false,
  dataSpacer: "",
  hasError: false,
  noResize: false
};